import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';
import * as NavActions from './customers.nav.actions';

export const initialState = {
  searchData: {
    searchTerm: '',
  },
  searchPerformed: false,
};

const handleCustomerSearch = (state, action) => {
  if (!action.searchData) {
    return state;
  }
  return {
    ...state,
    searchData: action.searchData,
    searchPerformed: true,
  };
};

const actionHandlerMap = {
  [NavActions.CUSTOMERS_SEARCH]: handleCustomerSearch,
  [NavActions.CUSTOMERS_SET_SEARCH_PERFORMED]: (state, { searchPerformed }) => {
    return {
      ...state,
      searchPerformed,
    };
  },
  [NavActions.CUSTOMERS_SEARCH_CLEAR_INPUT]: (state) => {
    return {
      ...state,
      searchData: { ...state.searchData, searchTerm: '' },
      searchPerformed: false,
    };
  },
  [NavActions.CUSTOMERS_SEARCH_TERM_CHANGE]: (state, action) => {
    return {
      ...state,
      searchData: { ...state.searchData, searchTerm: action.searchValue },
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './customers.nav.reducer.metadata';
